export default __webpack_public_path__ + "static/media/electricity.14c66956.svg";